import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('ssl_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function setToken(tok) {
  if (tok) localStorage.setItem('ssl_token', tok);
  else localStorage.removeItem('ssl_token');
}

export function fcfa(n) {
  if (n == null) return '—';
  return new Intl.NumberFormat('fr-FR').format(Math.round(n)) + ' FCFA';
}
